import {
  GridIcon,
  UserCircleIcon,
  ShoppingBagIcon,
  CreditCardIcon,
  UsersIcon,
  FileTextIcon,
  RefreshCwIcon,
  DatabaseIcon,
  ZapIcon,
  Gamepad2Icon,
  GlobeIcon,
  InfoIcon,
  MailIcon,
  ShieldIcon,
  FileBarChart2Icon,
  WalletIcon,
  UserCogIcon,
  HeadphonesIcon,
  PackageIcon,
  ArrowLeftRightIcon,
  ListIcon,
  HomeIcon,
  LockIcon,
  PercentIcon,

} from "lucide-react";

export const navItems = [
  {
    icon: <GridIcon className="w-5 h-5" />,
    name: "Dashboard",
    allowedRoles: ["merchant", "retailer"],
    subItems: [{ 
      name: "Ecommerce", 
      path: "/", 
      pro: false,  
      allowedRoles: ["merchant", "retailer"],
      icon: <ShoppingBagIcon className="w-4 h-4" />
    }],
  },
  {
    icon: <WalletIcon className="w-5 h-5" />,
    name: "Stock",
    allowedRoles: ["merchant", "retailer"],
    subItems: [
      { 
        name: "MyWallet", 
        path: "/manage-wallet", 
        pro: false,  
        allowedRoles: ["merchant", "retailer"],
        icon: <CreditCardIcon className="w-4 h-4" />
      },
      {
        name: "PurchaseStock",
        allowedRoles: ["merchant"],
        path: "/purchase-stock",
        pro: false,
        icon: <ShoppingBagIcon className="w-4 h-4" />
      },
      {
        name: "StockTransfer",
        allowedRoles: ["merchant"],
        path: "/stock-transfer-downline",
        pro: false,
        icon: <ArrowLeftRightIcon className="w-4 h-4" />
      },
      {
        name: "RequestReverse",
        allowedRoles: ["merchant"],
        path: "/request-reverse",
        pro: false,
        icon: <RefreshCwIcon className="w-4 h-4" />
      },
    ],
  },
  {
    icon: <UserCogIcon className="w-5 h-5" />,
    allowedRoles: ["merchant"],
    name: "MerchantManagement",
    subItems: [
      {
        name: "ManageAgent",
        allowedRoles: ["merchant"],
        path: "/manage-agent",
        pro: false,
        icon: <UsersIcon className="w-4 h-4" />
      },
      {
        name: "ManageSlabs",
        allowedRoles: ["merchant"],
        path: "/slabs",
        pro: false,
        icon: <PercentIcon className="w-4 h-4" />
      },
    ],
  },
   {
    icon: <PackageIcon className="w-5 h-5" />,
    name: "Products",
    allowedRoles: ["merchant", "retailer"],
    subItems: [
      { 
        name: "ProductList", 
        path: "/product-list", 
        pro: false,  
        allowedRoles: ["merchant", "retailer"],
        icon: <ListIcon className="w-4 h-4" />
      },
      { 
        name: "GamesList", 
        path: "/gameActivation", 
        pro: false,  
        allowedRoles: ["merchant", "retailer"],
        icon: <Gamepad2Icon className="w-4 h-4" />
      },
      { 
        name: "SocialList", 
        path: "/social-list", 
        pro: false,  
        allowedRoles: ["merchant", "retailer"],
        icon: <GlobeIcon className="w-4 h-4" />
      },
      {
        name: "Recharge",
        path: "/recharge",
        pro: false,
        allowedRoles: ["merchant", "retailer"],
        icon: <ZapIcon className="w-4 h-4" />
      },
    ],
  },
   {
    icon: <FileBarChart2Icon className="w-5 h-5" />,
    allowedRoles: ["merchant", "retailer"],
    name: "ProductsList",
    path: "/products",
  },
  {
    icon: <FileBarChart2Icon className="w-5 h-5" />,
    allowedRoles: ["merchant", "retailer"],
    name: "Statement",
    path: "/statment",
  },
  {
    icon: <RefreshCwIcon className="w-5 h-5" />,
    allowedRoles: ["merchant", "retailer"],
    name: "Rollback Report",
    path: "/agentRollbackReport",
  },
  {
    icon: <DatabaseIcon className="w-5 h-5" />,
    allowedRoles: ["merchant"],
    name: "Bulk Stock Transfer",
    path: "/bulkStockTransfer",
  },
  {
    icon: <ZapIcon className="w-5 h-5" />,
    allowedRoles: ["merchant", "retailer"],
    name: "Bulk Recharge",
    path: "/bulkRecharge",
  },
  {
    icon: <ShoppingBagIcon className="w-5 h-5" />,
    allowedRoles: ["merchant", "retailer"],
    name: "Order",
    path: "/order",
  },
 
];

export const othersItems = [
  {
    icon: <UserCircleIcon className="w-5 h-5" />,
    name: "UserProfile",
    path: "/profile",
    allowedRoles: ["merchant", "retailer", "customer"],
  },
  //   {
  //   icon: <UserCircleIcon className="w-5 h-5" />,
  //   name: "MerchantAPI",
  //   path: "/merchant-api-uat",
  //   allowedRoles: ["merchant", "retailer", "customer"],
  // },
  {
    icon: <HeadphonesIcon className="w-5 h-5" />,
    name: "Support",
    path: "/ticket-management",
    allowedRoles: ["merchant", "retailer", "customer"],
  },
  {
    icon: <InfoIcon className="w-5 h-5" />,
    name: "About US",
    path: "/AboutUs",
    allowedRoles: ["merchant", "retailer", "customer"],
  },
  {
    icon: <MailIcon className="w-5 h-5" />,
    name: "Contact Us",
    path: "/ContactUs",
    allowedRoles: ["merchant", "retailer", "customer"],
  },
  {
    icon: <ShieldIcon className="w-5 h-5" />,
    name: "Privacy Policy & Terms",
    allowedRoles: ["merchant", "retailer", "customer"],
    subItems: [
      { 
        name: "Privacy Policy", 
        path: "/Privacy", 
        pro: false,  
        allowedRoles: ["merchant", "retailer", "customer"],
        icon: <LockIcon className="w-4 h-4" />
      },
      { 
        name: "Terms and Conditions", 
        path: "/TermAndCondition", 
        pro: false,  
        allowedRoles: ["merchant", "retailer", "customer"],
        icon: <FileTextIcon className="w-4 h-4" />
      },
    ],
  },
];

export const customerNavItems = [
  {
    icon: <HomeIcon className="w-5 h-5" />,
    name: "Dashboard",
    path: "/customer-dashboard",
  },
  {
    icon: <ShoppingBagIcon className="w-5 h-5" />,
    name: "Order",
    path: "/customer-order",
  },
  {
    icon: <UserCircleIcon className="w-5 h-5" />,
    name: "UserProfile",
    path: "/customer-profile",
  },
  {
    icon: <HeadphonesIcon className="w-5 h-5" />,
    name: "Support",
    path: "/customer-support",
  },
];